import React from 'react';
import PropTypes from 'prop-types';

const AlertTriangle = ({color = 'currentColor', ...props}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 8.75006V5.0121M9 11.5207V11.5535M13.7249 14.6667H4.27506C2.98425 14.6667 1.89494 13.8136 1.55221 12.6465C1.40591 12.1482 1.58567 11.6293 1.86063 11.1874L6.58557 2.66756C7.69258 0.888643 10.3074 0.888646 11.4144 2.66756L16.1394 11.1874C16.4143 11.6293 16.5941 12.1482 16.4478 12.6465C16.1051 13.8136 15.0157 14.6667 13.7249 14.6667Z"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

AlertTriangle.propTypes = {
  color: PropTypes.string,
};

export default AlertTriangle;
